import { Box, Button, CircularProgress, Stack, Typography } from "@mui/material";
import { OssPanel } from "../common/OssPanel";
import { riskLevel } from "../../constants/labels";
import { formatDate } from "../../utils/calendarUtils";

const weekDays = ["일", "월", "화", "수", "목", "금", "토"];

export const OssCalendarGrid = ({ days, grouped, loading, month, onOpenOrder, onOpenDay }) => (
  <OssPanel sx={{ overflow: "hidden" }}>
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))", borderBottom: "1px solid #e5e7eb" }}>
      {weekDays.map((day) => (
        <Box key={day} sx={{ p: 1, textAlign: "center", bgcolor: "#f8fafc", fontSize: 13, fontWeight: 800, color: "#475569" }}>
          {day}
        </Box>
      ))}
    </Box>

    {loading ? (
      <Box sx={{ minHeight: 560, display: "grid", placeItems: "center" }}>
        <CircularProgress size={32} />
      </Box>
    ) : (
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, minmax(0, 1fr))" }}>
        {days.map((day) => {
          const key = formatDate(day);
          const inMonth = day.getMonth() === month.getMonth();
          const events = grouped.get(key) || [];
          return (
            <Box
              key={key}
              component="button"
              type="button"
              onClick={() => onOpenDay?.(key, events)}
              sx={{
                minHeight: { xs: 112, lg: 128 },
                p: 0.85,
                width: "100%",
                borderRight: "1px solid #e5e7eb",
                borderBottom: "1px solid #e5e7eb",
                borderTop: 0,
                borderLeft: 0,
                bgcolor: inMonth ? "#fff" : "#f8fafc",
                opacity: inMonth ? 1 : 0.55,
                overflow: "hidden",
                textAlign: "left",
                cursor: events.length ? "pointer" : "default",
              }}
            >
              <Typography sx={{ fontSize: 13, fontWeight: 800, color: "#111827" }}>
                {day.getDate()}
              </Typography>
              <Stack spacing={0.45} sx={{ mt: 0.65 }}>
                {events.slice(0, 4).map((event) => {
                  const meta = riskLevel[event.risk_level] || riskLevel.NORMAL;
                  return (
                    <Button
                      key={`${event.event_type}-${event.id}-${event.event_date}`}
                      onClick={(clickEvent) => {
                        clickEvent.stopPropagation();
                        onOpenOrder(event.order_id);
                      }}
                      sx={{
                        justifyContent: "flex-start",
                        minHeight: 24,
                        px: 0.75,
                        py: 0.25,
                        bgcolor: meta.bg,
                        color: meta.tone,
                        border: `1px solid ${meta.tone}22`,
                        fontSize: "11.5px !important",
                        fontWeight: "700 !important",
                        overflow: "hidden",
                        "&:hover": { bgcolor: meta.bg },
                      }}
                    >
                      <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {event.event_label} · {event.order_no}
                      </Box>
                    </Button>
                  );
                })}
                {events.length > 4 && (
                  <Typography sx={{ fontSize: 11.5, color: "#64748b" }}>
                    +{events.length - 4}건 더 있음
                  </Typography>
                )}
              </Stack>
            </Box>
          );
        })}
      </Box>
    )}
  </OssPanel>
);
